import { Component } from '@angular/core';
import { DynamicTable } from 'src/app/models/dynamic-table.model';

@Component({
  selector: 'app-dynamic-table',
  templateUrl: './dynamic-table.component.html',
  styleUrls: ['./dynamic-table.component.scss']
})
export class DynamicTableComponent {
  table: DynamicTable = new DynamicTable();

  sort(index) {
    var type = this.table.headers[index].type;
    var column = this.table.headers[index];
    for (let hea = 0; hea < this.table.headers.length; hea++) {
      const element = this.table.headers[hea];
      if (hea !== index) {
        element.sorted = null;
      }
    }
    if (column.sorted === null) {
      column.sorted = 1;
    } else {
      column.sorted = column.sorted === 1 ? 0 : 1;
    }

    this.table.filter = this.table.registers.sort((a, b) => {
      if (type === "number" || type == "price") {
        if (column.sorted === 1){
          return a.cells[index] - b.cells[index];
        } else  {
          return b.cells[index] - a.cells[index];
        }
      } else if (type === "string") {
        if (column.sorted === 1){
          return a.cells[index].localeCompare(b.cells[index], undefined, { sensitivity: 'base' })
        } else  {
          return b.cells[index].localeCompare(a.cells[index], undefined, { sensitivity: 'base' })
        }
      } else if (type == "date") {
        var dateA = new Date(a.cells[index]);
        var dateB = new Date(b.cells[index]);
        if (column.sorted === 1){
          return dateA.getTime() - dateB.getTime();
        } else  {
          return dateB.getTime() - dateA.getTime();
        }
      }
    });
  }

  group(h) {
    
  }
}
